(function () {
  const customProductUpdates = () => {
    const customProductSwatches = document.querySelectorAll(".custom-product-swatch");

    if (customProductSwatches.length) {
      customProductSwatches.map((swatch) => {
        swatch.addEventListener("click", function () {
          if (this.classList.contains("active-finish")) return;
          const mainWrapper = this.closest(".product-card-detail");
          const bundleForm = mainWrapper.closest(".product-bundles__form");
          const inputId = mainWrapper.querySelector(
            "[data-product-variant-id]"
          );

          // gets active color from previous active swatches
          const detailsWrapper = this.closest(".detail-wrapper");
          const prevColorSwatches = detailsWrapper.querySelector(
            ".custom-product-bundle-item__swatches.active"
          );
          const labelActiveImage =
            prevColorSwatches.querySelector("label.active img");
          const prevActiveColor = labelActiveImage.getAttribute("alt");

          // handles finish updates
          const activeSwatch = mainWrapper.querySelector(
            ".custom-product-swatch.active-finish"
          );
          if (activeSwatch) {
            activeSwatch.classList.remove("active-finish");
          }
          this.classList.add("active-finish");
          const parent = this.parentNode;
          const productId = parent.dataset.id;
          const swatchTitle = parent.dataset.swatchTitle;
          const bundleError = bundleForm.querySelector(
            ".product-bundles__error"
          );
          const swatchTitleHtmlElem = mainWrapper.querySelector(
            ".custom-product-bundle-item__finishes .finish-name"
          );
          if (swatchTitleHtmlElem) {
            swatchTitleHtmlElem.innerText = swatchTitle;
          }
          if (bundleError) {
            bundleError.style.display = "none";
          }

          const activeColorSwatches = mainWrapper.querySelector(
            ".custom-product-bundle-item__swatches.active"
          );
          const colorSwatchesWrapper = mainWrapper.querySelector(
            `[data-product-id="${productId}"]`
          );
          if (activeColorSwatches) {
            activeColorSwatches.classList.remove("active");
          }
          colorSwatchesWrapper.classList.add("active");
          // title and price updates
          const allProductsDetails = Array.from(
            mainWrapper.querySelectorAll(`[data-details-id]`)
          );
          const selectedProductsDetails = mainWrapper.querySelector(
            `[data-details-id="${productId}"]`
          );

          if (allProductsDetails.length)
            allProductsDetails.map((elem) => elem.classList.remove("active"));
          if (selectedProductsDetails)
            selectedProductsDetails.classList.add("active");

          // updates selected gem color title and image
          const activeSwatchOnSelect =
            colorSwatchesWrapper.querySelector("label.active");
          const firstColorSwatch = Array.from(
            colorSwatchesWrapper.querySelectorAll(".swatch-element")
          )[0].querySelector("label");
          const activeSwatchAlt = firstColorSwatch
            .querySelector("img")
            .getAttribute("alt");
          const selectedColorOnActive = colorSwatchesWrapper.querySelector(
            `[data-swatch-title="${prevActiveColor}"]`
          );
          const colorTitle = colorSwatchesWrapper.querySelector(".finish-name");
          const mainImage = mainWrapper.querySelector(".image-wrapper img");

          if (selectedColorOnActive) {
            const selectedColorOnActiveImage =
              selectedColorOnActive.dataset.image;
            const selectedColorOnActiveSecondImage =
              selectedColorOnActive.dataset.secondImage;
            const selectedColorOnActiveLabel =
              selectedColorOnActive.querySelector("label");

            if (activeSwatchOnSelect)
              activeSwatchOnSelect.classList.remove("active");
            if (selectedColorOnActiveLabel) {
              selectedColorOnActiveLabel.classList.add("active");
              const selectedColorOnActiveVariantId =
                selectedColorOnActiveLabel.parentNode.dataset.variantId;
              const selectedColorOnActiveInventory =
                selectedColorOnActiveLabel.parentNode.dataset.inventory;
              if (inputId && selectedColorOnActiveVariantId) {
                inputId.value = selectedColorOnActiveVariantId;
                inputId.setAttribute(
                  "data-inventory",
                  selectedColorOnActiveInventory
                );
              }
            }
            if (colorTitle) colorTitle.innerText = prevActiveColor;
            if (mainImage) {
              if (selectedColorOnActiveImage.includes("no-image")) {
                mainImage.src = selectedColorOnActiveSecondImage;
              } else {
                mainImage.src = selectedColorOnActiveImage;
              }
            }
          } else {
            if (activeSwatchOnSelect)
              activeSwatchOnSelect.classList.remove("active");
            if (firstColorSwatch) {
              firstColorSwatch.classList.add("active");
              const firstColorSwatchParent = firstColorSwatch.parentNode;
              const firstColorSwatchVariantId =
                firstColorSwatchParent.dataset.variantId;
              const firstColorSwatchInventory =
                firstColorSwatchParent.dataset.inventory;
              const firstColorSwatchParentImage =
                firstColorSwatchParent.dataset.image;
              const firstColorSwatchParentSecondImage =
                firstColorSwatchParent.dataset.secondImage;
              if (firstColorSwatchParentImage.includes("no-image")) {
                if (mainImage && firstColorSwatchParentSecondImage) {
                  mainImage.src = firstColorSwatchParentSecondImage;
                }
              } else {
                if (mainImage && firstColorSwatchParentImage) {
                  mainImage.src = firstColorSwatchParentImage;
                }
              }
              if (inputId && firstColorSwatchVariantId) {
                inputId.value = firstColorSwatchVariantId;
                inputId.setAttribute(
                  "data-inventory",
                  firstColorSwatchInventory
                );
              }
            }
            if (colorTitle) colorTitle.innerText = activeSwatchAlt;
          }
        });
      });
    }
  };
  customProductUpdates();
})();
